/* eslint-disable */
import Helpers from '../util/Helpers';
import ExecutaRest from '../util/ExecutaRest'


class RelatorioApi {

static ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(parametros){
        
        var rest = new ExecutaRest();

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarTotalMensagemPorClassificacaoPorIdEstruturaPaiHierarquiaREST', parametros).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Total Mensagem Por Classificacao Por IdEstruturaPai : '+ retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado: ' + error/*areaTratamento.statusText*/);
            });

        });
    }



static ListarTotalMensagemPorSituacaoEstrutura(parametros, tipicasOuvidoria){

        var rest = new ExecutaRest();

        var objPesquisaTela = Object.assign({}, parametros,
            {
                tipicasOuvidoria: tipicasOuvidoria
            });

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarTotalMensagemPorSituacaoEstruturaREST', objPesquisaTela).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Total Mensagem Por Classificacao Por IdEstruturaPai : '+ retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Total Mensagem Por situação Por IdEstruturaPai : '+ + error);
            });
        });
    }


static ListarTempoRespostaPorFaixa(parametros, tipicasOuvidoria){

        var rest = new ExecutaRest();

        var objPesquisaTela = Object.assign({}, parametros,
            {
                tipicasOuvidoria: tipicasOuvidoria
            });

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarTempoRespostaPorFaixaREST', objPesquisaTela).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Por Faixa REST : '+ retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Por Faixa REST : : ' + error);
            });
        });
     
}


static ListarTempoRespostaClassificacaoPorFaixa(parametros, tipicasOuvidoria){
    
            var rest = new ExecutaRest();
    
            var objPesquisaTela = Object.assign({}, parametros,
                {
                    tipicasOuvidoria: tipicasOuvidoria
                });
    
            return new Promise(function(resolve, reject) {
    
                rest.Post('RelatorioSL.svc/rest/ListarTempoRespostaClassificacaoPorFaixaREST', objPesquisaTela).then(retorno => {
                    if (retorno.dado) {
                        resolve(Object.assign({}, retorno));
                    } else if (retorno.erro) {
                        reject(retorno.erro);
                    }
                    else if(retorno.dado=== null && retorno.erro=== null){
                            resolve(Object.assign({}, retorno));    
                    }
                    else{
                            reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Classificacao Por Faixa REST : '+ retorno.statusText);
                    } 
                }).catch(error => {
                    reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Classificacao Por Faixa REST : : ' + error);
                });
            });
         
    }
static IndicadorTempoRespostaPorFaixa(parametros){
        var rest = new ExecutaRest();
        
        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/IndicadorTempoRespostaPorFaixaHierarquicoREST', parametros).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Por Faixa REST : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Tempo Resposta Por Faixa REST : '+  error);
            });
        });
    }

    static IndicadorNivelClassificacao(parametros){
        var rest = new ExecutaRest();
        
        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/IndicadorNivelClassificacaoREST', parametros).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Indicador Nivel Classificacao REST : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Indicador Nivel Classificacao REST : '+  error);
            });
        });
    }

    static ListarEstruturasPorClassificacaoEstrutura(parametros){
        var rest = new ExecutaRest();
        
        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarEstruturasPorClassificacaoEstruturaREST', parametros).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Estruturas Por Classificacao Estrutura : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Estruturas Por Classificacao Estrutura : '+  error);
            });
        });
    }

    static ListarTop5AssuntosEstrutura(parametros){
        var rest = new ExecutaRest();
        
        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarTop5AssuntosEstruturaREST', parametros).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Top5 Assuntos Estrutura: '+ retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Top5 Assuntos Estrutura: '+  error);
            });
        });
    }

    static ObterQuantitativoManifestacoesIntervaloAno(parametros, tipicasOuvidoria, anos){
        var rest = new ExecutaRest();

        var objPesquisaTela = Object.assign({}, parametros,
            {
                anos: anos,
                tipicasOuvidoria: tipicasOuvidoria
            });

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ObterQuantitativoManifestacoesIntervaloAnoPorIdEstruturaREST', objPesquisaTela).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Obter Quantitativo Manifestacoes Intervalo Ano : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Obter Quantitativo Manifestacoes Intervalo Ano : '+  error);
            });
        });
    }

    static ListarAssuntosComTotalHierarquico(parametros, tipicasOuvidoria, idAssuntoPai){
        var rest = new ExecutaRest();
        
        var objPesquisaTela = Object.assign({}, parametros,
            {
                tipicasOuvidoria: tipicasOuvidoria,
                idAssuntoPai: idAssuntoPai
            });

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarAssuntosComTotalHierarquicoPorIdEstruturaREST', objPesquisaTela).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Assuntos Com Total Hierarquico por Id estrutura REST : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Assuntos Com Total HierarquicoREST : '+ error);
            });
        });
    }

    static ListarEstruturasComTotalHierarquico(parametros, tipicasOuvidoria, idEstruturaPai){
        var rest = new ExecutaRest();
        
        var objPesquisaTela = Object.assign({}, parametros,
            {
                tipicasOuvidoria: tipicasOuvidoria,
                idEstruturaPai: idEstruturaPai
            });

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarEstruturasComTotalHierarquicoREST', objPesquisaTela).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Estruturas Com Total HierarquicoREST : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> Listar Estruturas Com Total HierarquicoREST : '+ error);
            });
        });
    }


    static ListarDirecionamentoGrupoTratamento(parametros){
        var rest = new ExecutaRest();

        return new Promise(function(resolve, reject) {

            rest.Post('RelatorioSL.svc/rest/ListarDirecionadasGrupoTratamentoREST', parametros).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
                else if(retorno.dado=== null && retorno.erro=== null){
                        resolve(Object.assign({}, retorno));    
                }
                else{
                        reject('Ocorreu um erro inesperado em RELATÓRIO --> ListarDirecionamentoGrupoTratamento : '+  retorno.statusText);
                } 
            }).catch(error => {
                reject('Ocorreu um erro inesperado em RELATÓRIO --> ListarDirecionamentoGrupoTratamento : '+ error);
            });
        });
    }
}

 export default RelatorioApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/relatorioApi.js
 **/